module.exports = __webpack_public_path__ + "static/sport/register-success.a73ab13.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/sport5/register-success.png
// module id = TXb0
// module chunks = 0